module.exports = __webpack_public_path__ + "static/media/SINGLE BREASTED 5 BUTTONS.92178e01.svg";